import { DocumentsItem } from '@networkteam/giraffe';

import Logo from '@/lib/assets/eva-kita-logo.svg';
import Link from 'next/link';
import Navigation from './Navigation';
import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Close, Menu } from './icons';

type HeaderProps = {
  navigationItems: DocumentsItem[];
};

const BASE_URL = process.env.PUBLIC_BASE_URL || 'https://www.eva-kita.de';

const Header = ({ navigationItems }: HeaderProps) => {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const media = window.matchMedia('(min-width: 1280px)');

    const mediaChangeHandler = (e: MediaQueryListEvent) => {
      if (e.matches) {
        setMenuOpen(false);
      }
    };

    media.addEventListener('change', mediaChangeHandler);

    return () => {
      media.removeEventListener('change', mediaChangeHandler);
    };
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [menuOpen]);

  return (
    <header>
      <div
        className={classNames(
          'container mx-auto p-4 md:px-8 md:py-14 xl:flex xl:items-center xl:justify-between xl:gap-x-8',
          {
            'left-0 right-0 top-0 z-[120] max-xl:fixed': menuOpen,
          }
        )}
      >
        <div className="flex items-center justify-between gap-x-8">
          <Link href={BASE_URL}>
            <Logo className="relative z-50 w-48 shrink-0 md:w-64" />
          </Link>
          <button
            className={classNames('relative z-50 border bg-sand-100 p-3 xl:hidden', {
              'border-grey-600': menuOpen,
              'border-transparent': !menuOpen,
            })}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? (
              <>
                <Close className="h-6 w-6" />
                <span className="sr-only">Menü schließen</span>
              </>
            ) : (
              <>
                <Menu className="h-6 w-6" />
                <span className="sr-only">Menü öffnen</span>
              </>
            )}
          </button>
        </div>
        <Navigation navigationItems={navigationItems} menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      </div>
    </header>
  );
};

export default Header;
